import { render, staticRenderFns } from "./MenuManagementMinimalized.vue?vue&type=template&id=23a1d4a7"
import script from "./MenuManagementMinimalized.vue?vue&type=script&lang=js"
export * from "./MenuManagementMinimalized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports